import React, { useContext } from 'react'
import Button from '@material-ui/core/Button'
import { navigate } from '@reach/router';
import AuthContext from '../../services/firebase/AuthContext';
import { unsubscribeAll } from '../../services/firebase/useful';

const SignOut = ({variant = "contained", color = "inherit", buttonText = 'Logout'}) => {
    const { logout } = useContext(AuthContext);
    
    const handleClick = async () => {
        unsubscribeAll();
        await logout();
        navigate("/");
    }

    return (
            <Button variant={variant} color={color} style={{marginLeft: 'auto'}} onClick={handleClick}>{buttonText}</Button>
    )
}

export default SignOut;